
import { faBedPulse, faBookMedical, faHospital, faHouseMedical, faPrescriptionBottleMedical, faTimeline, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Col, Row } from "react-bootstrap";
import { EXPLAIN_REVIEW_ADMIT_DC, EXPLAIN_REVIEW_EDD, EXPLAIN_REVIEW_REVISIT } from "../../amplify/api-gateway/write";

const TYPE_TO_CONFIG: any = {
    "explain_monitor": {
        title: "Monitor Summary",
        img: "/hero-otter-swimming.png",
        description: "Generate a summary of a patient's continuous monitoring data in the context of their medical history and current visit.",
        icon: faBedPulse,
        color: "pink"
    },
    "explain_sx_rx": {
        title: "Symptom Management",
        img: "/hero-otter-swimming.png",
        description: "Generate an evidence-based assessment of a patient's symptoms and management strategies.",
        icon: faPrescriptionBottleMedical,
        color: "pink"
    },
    "explain_palliative": {
        title: "Palliative Care Assessment",
        img: "/hero-otter-hiding.png",
        description: "Create an assessment covering advance care planning, goals of care, prognosis, legal consents, and family communication.",
        icon: faHouseMedical,
        color: "blue"
    },
    "explain_patient_summary": {
        title: "Patient Summary",
        img: "/hero-otter-swimming.png",
        description: "Assess the patient's past history using past clinical notes and structured visit information.",
        icon: faUser,
        color: "pink"
    },
    "explain_current_visit": {
        title: "Current Visit Summary",
        img: "/hero-otter-hiding.png",
        description: "Summarize the patient's current clinical situation using past clinical notes and reasons for visit.",
        icon: faHospital,
        color: "blue"
    },
    "explain_ddx": {
        title: "Differential Diagnosis",
        img: "/hero-penguin-island.png",
        description: "Generate a differential diagnosis based on clinical context, past patient notes, and imaging studies.",
        icon: faBookMedical,
        color: "orange"
    },
    "explain_charting": {
        title: "Charting",
        img: "/hero-otter-sleeping.png",
        description: "Review patient timeline to identify and explain significant events within the context of the patient visit.",
        icon: faTimeline,
        color: "pink"
    },
    "explain_risk": {
        title: "Risk",
        img: "/hero-otter-sleeping.png",
        description: "Produce an evidence-based assessment of a patient's clinical risk factors based on predictive models and clinical notes.",
        icon: faTimeline,
        color: "pink"
    },
    [EXPLAIN_REVIEW_ADMIT_DC]: {
        title: "Hospital Admission Review",
        img: "/hero-otter-sleeping.png",
        description: "Review the structured case analysis summarizing the ED and hospital course. Focus on whether the prospective and retrospective level-of-care assessments, diagnostic clarity, and modifiable admission opportunities match your clinical judgment. Confirm accuracy or suggest edits where needed.",
        icon: faTimeline,
        color: "pink"
    },
    [EXPLAIN_REVIEW_REVISIT]: {
        title: "ED Revisits Review - Predictability & Preventability Assessment",
        img: "/hero-otter-sleeping.png",
        description: "Review the structured analysis comparing the index ED visit and a revisit within 30 days. Confirm whether the classifications for predictability, preventability, post-discharge monitoring opportunity, and discharge instruction adequacy align with your clinical judgment. Ensure the visit summaries and thematic labels accurately reflect the cases, and suggest corrections where needed.",
        icon: faTimeline,
        color: "pink"
    },
    [EXPLAIN_REVIEW_EDD]: {
        title: "ED Discharge Review",
        img: "/hero-otter-sleeping.png",
        description: "Generates a structured expert review of an emergency department visit and discharge, summarizing the case for both clinicians and patients, classifying care value and acuity, and highlighting insights for longitudinal care.",
        icon: faTimeline,
        color: "pink"
    },
};

export const GenerateModuleHeroV2 = (props: {
    type: string,
    setRegenerateTarget: any,
    setShowContextMenu: any,
}) => {

    if (!TYPE_TO_CONFIG[props.type]) {
        return <></>;
    }

    return (
        <Card className="mt-2 mb-2 dashboard-actions-box" onClick={() => {props.setRegenerateTarget(props.type); props.setShowContextMenu(true)}}>
            <Card.Body>
                <Row className="mb-3">
                    <Col md={12} className="text-left">
                        <div className="d-flex align-items-center">
                            <span className={`dashboard-actions-circle-small dashboard-actions-circle-${TYPE_TO_CONFIG[props.type].color} me-2`}><FontAwesomeIcon icon={TYPE_TO_CONFIG[props.type].icon} fixedWidth /></span>

                            <strong>{TYPE_TO_CONFIG[props.type].title}</strong>
                        </div>
                    </Col>
                </Row>
                {/* {
                    TYPE_TO_CONFIG[props.type].img && (
                        <Row className="mb-3">
                            <Col md={12} className="text-left">
                                <img
                                    alt={TYPE_TO_CONFIG[props.type].title}
                                    src={TYPE_TO_CONFIG[props.type].img}
                                    style={{ objectFit: 'contain', width: '100%', height: '120px' }}
                                />
                            </Col>
                        </Row>
                    )
                } */}
                <Row>
                    <Col md={12}>
                        {TYPE_TO_CONFIG[props.type].description}
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};
